// extracted by mini-css-extract-plugin
export default {"pagination_container":"CallList_pagination_container__CQQzv"};